var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-2", attrs: { "data-runs": "" } },
    [
      _vm._t("title", [
        _c("div", { staticClass: "card-header" }, [
          _c("h1", { staticClass: "text-center" }, [
            _vm._v(_vm._s(_vm.T.wordsGlobalSubmissions))
          ])
        ])
      ]),
      _c(
        "div",
        {
          staticClass: "px-2 px-sm-4 border-0",
          class: {
            "single-problem-runs": !_vm.showAllRuns,
            "all-runs": _vm.showAllRuns
          }
        },
        [
          _c("div", [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.T.wordsSubmissions))
            ]),
            _vm.showPager
              ? _c("div", [
                  _c("div", { staticClass: "pager-controls" }, [
                    _c(
                      "button",
                      {
                        attrs: {
                          "data-button-page-previous": "",
                          disabled: _vm.filterOffset <= 0
                        },
                        on: {
                          click: function($event) {
                            _vm.filterOffset--
                          }
                        }
                      },
                      [_vm._v(" < ")]
                    ),
                    _vm._v(" " + _vm._s(_vm.currentPage) + " "),
                    _c(
                      "button",
                      {
                        attrs: {
                          "data-button-page-next": "",
                          disabled:
                            _vm.totalRuns &&
                            Math.ceil(_vm.totalRuns / _vm.rowCount) ==
                              _vm.currentPage
                        },
                        on: {
                          click: function($event) {
                            _vm.filterOffset++
                          }
                        }
                      },
                      [_vm._v(" > ")]
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "filters row" },
                    [
                      _c(
                        "label",
                        { staticClass: "col-3 col-sm pr-0 font-weight-bold" },
                        [
                          _vm._v(_vm._s(_vm.T.wordsVerdict) + ": "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filterVerdict,
                                  expression: "filterVerdict"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { "data-select-verdict": "" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.filterVerdict = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(_vm._s(_vm.T.wordsAll))
                              ]),
                              _c("option", { attrs: { value: "AC" } }, [
                                _vm._v("AC")
                              ]),
                              _c("option", { attrs: { value: "PA" } }, [
                                _vm._v("PA")
                              ]),
                              _c("option", { attrs: { value: "WA" } }, [
                                _vm._v("WA")
                              ]),
                              _c("option", { attrs: { value: "TLE" } }, [
                                _vm._v("TLE")
                              ]),
                              _c("option", { attrs: { value: "MLE" } }, [
                                _vm._v("MLE")
                              ]),
                              _c("option", { attrs: { value: "OLE" } }, [
                                _vm._v("OLE")
                              ]),
                              _c("option", { attrs: { value: "RTE" } }, [
                                _vm._v("RTE")
                              ]),
                              _c("option", { attrs: { value: "RFE" } }, [
                                _vm._v("RFE")
                              ]),
                              _c("option", { attrs: { value: "CE" } }, [
                                _vm._v("CE")
                              ]),
                              _c("option", { attrs: { value: "JE" } }, [
                                _vm._v("JE")
                              ]),
                              _c("option", { attrs: { value: "VE" } }, [
                                _vm._v("VE")
                              ]),
                              _c("option", { attrs: { value: "NO-AC" } }, [
                                _vm._v("No AC")
                              ])
                            ]
                          )
                        ]
                      ),
                      _c(
                        "label",
                        { staticClass: "col-3 col-sm pr-0 font-weight-bold" },
                        [
                          _vm._v(_vm._s(_vm.T.wordsStatus) + ": "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filterStatus,
                                  expression: "filterStatus"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { "data-select-status": "" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.filterStatus = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(_vm._s(_vm.T.wordsAll))
                              ]),
                              _c("option", { attrs: { value: "new" } }, [
                                _vm._v("new")
                              ]),
                              _c("option", { attrs: { value: "waiting" } }, [
                                _vm._v("waiting")
                              ]),
                              _c("option", { attrs: { value: "compiling" } }, [
                                _vm._v("compiling")
                              ]),
                              _c("option", { attrs: { value: "running" } }, [
                                _vm._v("running")
                              ]),
                              _c("option", { attrs: { value: "ready" } }, [
                                _vm._v("ready")
                              ])
                            ]
                          )
                        ]
                      ),
                      _c(
                        "label",
                        { staticClass: "col-5 col-sm pr-0 font-weight-bold" },
                        [
                          _vm._v(_vm._s(_vm.T.wordsLanguage) + ": "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.filterLanguage,
                                  expression: "filterLanguage"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { "data-select-language": "" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.filterLanguage = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(_vm._s(_vm.T.wordsAll))
                              ]),
                              _c("option", { attrs: { value: "cpp20-gcc" } }, [
                                _vm._v("C++20 (g++ 10.3)")
                              ]),
                              _c(
                                "option",
                                { attrs: { value: "cpp20-clang" } },
                                [_vm._v("C++20 (clang++ 10.0)")]
                              ),
                              _c("option", { attrs: { value: "cpp17-gcc" } }, [
                                _vm._v("C++17 (g++ 10.3)")
                              ]),
                              _c(
                                "option",
                                { attrs: { value: "cpp17-clang" } },
                                [_vm._v("C++17 (clang++ 10.0)")]
                              ),
                              _c("option", { attrs: { value: "cpp11-gcc" } }, [
                                _vm._v("C++11 (g++ 10.3)")
                              ]),
                              _c(
                                "option",
                                { attrs: { value: "cpp11-clang" } },
                                [_vm._v("C++11 (clang++ 10.0)")]
                              ),
                              _c("option", { attrs: { value: "c11-gcc" } }, [
                                _vm._v("C (gcc 10.3)")
                              ]),
                              _c("option", { attrs: { value: "c11-clang" } }, [
                                _vm._v("C (clang 10.0)")
                              ]),
                              _c("option", { attrs: { value: "cs" } }, [
                                _vm._v("C# (10, dotnet 6.0)")
                              ]),
                              _c("option", { attrs: { value: "hs" } }, [
                                _vm._v("Haskell (ghc 8.8)")
                              ]),
                              _c("option", { attrs: { value: "java" } }, [
                                _vm._v("Java (openjdk 16.0)")
                              ]),
                              _c("option", { attrs: { value: "kt" } }, [
                                _vm._v("Kotlin (1.6.10)")
                              ]),
                              _c("option", { attrs: { value: "pas" } }, [
                                _vm._v("Pascal (fpc 3.0)")
                              ]),
                              _c("option", { attrs: { value: "py3" } }, [
                                _vm._v("Python (3.9)")
                              ]),
                              _c("option", { attrs: { value: "py2" } }, [
                                _vm._v("Python (2.7)")
                              ]),
                              _c("option", { attrs: { value: "rb" } }, [
                                _vm._v("Ruby (2.7)")
                              ]),
                              _c("option", { attrs: { value: "lua" } }, [
                                _vm._v("Lua (5.3)")
                              ]),
                              _c("option", { attrs: { value: "go" } }, [
                                _vm._v("Go (1.18.beta2)")
                              ]),
                              _c("option", { attrs: { value: "rs" } }, [
                                _vm._v("Rust (1.56.1)")
                              ]),
                              _c("option", { attrs: { value: "js" } }, [
                                _vm._v("JavaScript (Node.js 16)")
                              ]),
                              _c("option", { attrs: { value: "kp" } }, [
                                _vm._v("Karel (Pascal)")
                              ]),
                              _c("option", { attrs: { value: "kj" } }, [
                                _vm._v("Karel (Java)")
                              ]),
                              _c("option", { attrs: { value: "cat" } }, [
                                _vm._v(_vm._s(_vm.T.wordsJustOutput))
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm.showProblem
                        ? [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "col-6 col-sm pr-1 font-weight-bold"
                              },
                              [
                                _vm._v(_vm._s(_vm.T.wordsProblem) + ": "),
                                _c("omegaup-common-typeahead", {
                                  attrs: {
                                    "data-search-problem": "",
                                    "existing-options":
                                      _vm.searchResultProblems,
                                    value: _vm.filterProblem
                                  },
                                  on: {
                                    "update:value": function($event) {
                                      _vm.filterProblem = $event
                                    },
                                    "update-existing-options": function(query) {
                                      return _vm.$emit(
                                        "update-search-result-problems",
                                        query
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "close",
                                staticStyle: { float: "none" },
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.filterProblem = null
                                  }
                                }
                              },
                              [_vm._v(" × ")]
                            )
                          ]
                        : _vm._e(),
                      _vm.showUser
                        ? [
                            _c(
                              "label",
                              { staticClass: "col-5 col-sm font-weight-bold" },
                              [
                                _vm._v(_vm._s(_vm.T.contestParticipant) + ": "),
                                _c("omegaup-common-typeahead", {
                                  attrs: {
                                    "data-search-username": "",
                                    "existing-options": _vm.searchResultUsers,
                                    value: _vm.filterUsername,
                                    "max-results": 10
                                  },
                                  on: {
                                    "update:value": function($event) {
                                      _vm.filterUsername = $event
                                    },
                                    "update-existing-options":
                                      _vm.updateSearchResultUsers
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c("div", { staticClass: "row" }, [
                    _vm.filtersExcludingOffset.length > 0
                      ? _c(
                          "div",
                          { staticClass: "col-sm col-12" },
                          [
                            _vm._l(_vm.filtersExcludingOffset, function(
                              filter
                            ) {
                              return _c(
                                "span",
                                {
                                  key: filter.name,
                                  staticClass: "btn-secondary mr-3"
                                },
                                [
                                  _c("span", { staticClass: "mr-2" }, [
                                    _vm._v(
                                      _vm._s(filter.name) +
                                        ": " +
                                        _vm._s(filter.value)
                                    )
                                  ]),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        "data-remove-filter": filter.name
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.onRemoveFilter(filter.name)
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "times"] }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "#runs",
                                  "data-remove-all-filters": ""
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onRemoveFilter("all")
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "mr-2" }, [
                                  _vm._v(_vm._s(_vm.T.wordsRemoveFilter))
                                ])
                              ]
                            )
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ])
              : _vm._e()
          ]),
          _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table runs" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", { staticClass: "text-nowrap" }, [
                    _vm._v(_vm._s(_vm.T.wordsTime))
                  ]),
                  _c("th", [_vm._v("GUID")]),
                  _vm.showUser
                    ? _c("th", [_vm._v(_vm._s(_vm.T.contestParticipant))])
                    : _vm._e(),
                  _vm.showContest
                    ? _c("th", [_vm._v(_vm._s(_vm.T.wordsContest))])
                    : _vm._e(),
                  _vm.showProblem
                    ? _c("th", [_vm._v(_vm._s(_vm.T.wordsProblem))])
                    : _vm._e(),
                  _c("th", [_vm._v(_vm._s(_vm.T.wordsStatus))]),
                  _vm.showPoints
                    ? _c("th", { staticClass: "numeric" }, [
                        _vm._v(_vm._s(_vm.T.wordsPoints))
                      ])
                    : _vm._e(),
                  _vm.showPoints
                    ? _c("th", { staticClass: "numeric" }, [
                        _vm._v(_vm._s(_vm.T.wordsPenalty))
                      ])
                    : _vm._e(),
                  !_vm.showPoints
                    ? _c("th", { staticClass: "numeric" }, [
                        _vm._v(" " + _vm._s(_vm.T.wordsPercentage) + " ")
                      ])
                    : _vm._e(),
                  _c("th", [_vm._v(_vm._s(_vm.T.wordsLanguage))]),
                  _c("th", { staticClass: "numeric" }, [
                    _vm._v(_vm._s(_vm.T.wordsMemory))
                  ]),
                  _c("th", { staticClass: "numeric" }, [
                    _vm._v(_vm._s(_vm.T.wordsRuntime))
                  ]),
                  _vm.showDetails && !_vm.showDisqualify && !_vm.showRejudge
                    ? _c("th", [
                        _vm._v(" " + _vm._s(_vm.T.arenaRunsActions) + " ")
                      ])
                    : _c("th")
                ])
              ]),
              _vm.problemAlias != null
                ? _c("tfoot", [
                    _c("tr", [
                      _c(
                        "td",
                        { attrs: { colspan: "10", "data-new-run": "" } },
                        [
                          _vm.isContestFinished
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "/arena/" +
                                      _vm.contestAlias +
                                      "/practice/"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.T.arenaContestEndedUsePractice)
                                  )
                                ]
                              )
                            : _vm.useNewSubmissionButton
                            ? _c(
                                "button",
                                {
                                  staticClass: "w-100",
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit("new-submission")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.newSubmissionDescription) +
                                      " "
                                  )
                                ]
                              )
                            : _c(
                                "a",
                                {
                                  attrs: { href: _vm.newSubmissionUrl },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit("new-submission")
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.newSubmissionDescription))]
                              )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _c(
                "tbody",
                _vm._l(_vm.filteredRuns, function(run) {
                  return _c("tr", { key: run.guid }, [
                    _c("td", [
                      _vm._v(_vm._s(_vm.time.formatDateLocalHHMM(run.time)))
                    ]),
                    _c(
                      "td",
                      [
                        _c(
                          "acronym",
                          { attrs: { title: run.guid, "data-run-guid": "" } },
                          [
                            _c("tt", [_vm._v(_vm._s(run.guid.substring(0, 8)))])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.showUser
                      ? _c(
                          "td",
                          {
                            staticClass: "text-break-all text-nowrap",
                            attrs: { "data-username": run.username }
                          },
                          [
                            _c("omegaup-user-username", {
                              attrs: {
                                classname: run.classname,
                                username: run.username,
                                country: run.country_id,
                                linkify: true,
                                href: "#runs",
                                "emit-click-event": true
                              },
                              on: {
                                click: function(username) {
                                  return (_vm.filterUsername = {
                                    key: username,
                                    value: username
                                  })
                                }
                              }
                            }),
                            _c(
                              "a",
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  href: "/profile/" + run.username + "/"
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: ["fas", "external-link-alt"] }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.showContest
                      ? _c("td", { staticClass: "text-break-all" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "#runs" },
                              on: {
                                click: function($event) {
                                  return _vm.onEmitFilterChanged({
                                    filter: "contest",
                                    value: run.contest_alias
                                  })
                                }
                              }
                            },
                            [_vm._v(_vm._s(run.contest_alias))]
                          ),
                          run.contest_alias
                            ? _c(
                                "a",
                                {
                                  staticClass: "ml-2",
                                  attrs: {
                                    href: "/arena/" + run.contest_alias + "/"
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: {
                                      icon: ["fas", "external-link-alt"]
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm.showProblem
                      ? _c("td", { staticClass: "text-break-all" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "#runs" },
                              on: {
                                click: function($event) {
                                  return _vm.setFilterProblem(run.alias)
                                }
                              }
                            },
                            [_vm._v(_vm._s(run.alias))]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                "problem-navigation-button": "",
                                href: "/arena/problem/" + run.alias + "/"
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "external-link-alt"] }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _c(
                      "td",
                      {
                        staticClass: "text-center opacity-4 font-weight-bold",
                        class: _vm.statusClass(run),
                        attrs: { "data-run-status": "" }
                      },
                      [
                        _c("span", { staticClass: "mr-1" }, [
                          _vm._v(_vm._s(_vm.status(run)))
                        ]),
                        !!_vm.statusHelp(run)
                          ? _c(
                              "button",
                              {
                                staticClass: "btn-outline-dark btn-sm",
                                attrs: {
                                  type: "button",
                                  "data-content": _vm.statusHelp(run),
                                  "data-toggle": "popover",
                                  "data-trigger": "focus"
                                },
                                on: { click: _vm.showVerdictHelp }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: ["fas", "question-circle"] }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm.showPoints
                      ? _c("td", { staticClass: "numeric" }, [
                          _vm._v(_vm._s(_vm.points(run)))
                        ])
                      : _vm._e(),
                    _vm.showPoints
                      ? _c("td", { staticClass: "numeric" }, [
                          _vm._v(_vm._s(_vm.penalty(run)))
                        ])
                      : _vm._e(),
                    !_vm.showPoints
                      ? _c("td", { staticClass: "numeric" }, [
                          _vm._v(_vm._s(_vm.percentage(run)))
                        ])
                      : _vm._e(),
                    _c("td", [_vm._v(_vm._s(run.language))]),
                    _c("td", { staticClass: "numeric" }, [
                      _vm._v(_vm._s(_vm.memory(run)))
                    ]),
                    _c("td", { staticClass: "numeric" }, [
                      _vm._v(_vm._s(_vm.runtime(run)))
                    ]),
                    _vm.showDetails && !_vm.showDisqualify && !_vm.showRejudge
                      ? _c("td", [
                          _c(
                            "button",
                            {
                              staticClass: "details btn-outline-dark btn-sm",
                              attrs: { "data-run-details": run.guid },
                              on: {
                                click: function($event) {
                                  return _vm.onRunDetails(run)
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "search-plus"] }
                              })
                            ],
                            1
                          ),
                          _vm.requestFeedback
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "details btn-outline-dark btn-sm",
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit(
                                        "request-feedback",
                                        run.guid
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: {
                                      title: _vm.T.courseRequestFeedback,
                                      icon: "comment-dots"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      : _vm.showDetails || _vm.showDisqualify || _vm.showRejudge
                      ? _c("td", { attrs: { "data-actions": run.guid } }, [
                          _c("div", { staticClass: "dropdown" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-secondary dropdown-toggle",
                                attrs: {
                                  "data-runs-actions-button": "",
                                  type: "button",
                                  "data-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false"
                                }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.T.arenaRunsActions) + " "
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "dropdown-menu" },
                              [
                                _vm.showDetails
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn-link dropdown-item",
                                        attrs: {
                                          "data-runs-show-details-button": "",
                                          "data-run-details": run.guid
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.onRunDetails(run)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.T.arenaRunsActionsDetails
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.showRejudge
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn-link dropdown-item",
                                        attrs: {
                                          "data-actions-rejudge": run.guid
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.$emit("rejudge", run)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.T.arenaRunsActionsRejudge
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.showDisqualify
                                  ? [
                                      _c("div", {
                                        staticClass: "dropdown-divider"
                                      }),
                                      run.type === "normal"
                                        ? [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn-link dropdown-item",
                                                attrs: {
                                                  "data-actions-disqualify-by-guid":
                                                    run.guid
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.$emit(
                                                      "disqualify",
                                                      {
                                                        run: run,
                                                        disqualificationType:
                                                          _vm
                                                            .DisqualificationType
                                                            .ByGUID
                                                      }
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.T
                                                        .arenaRunsActionsDisqualifyByGUID
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            ),
                                            _vm.inContest
                                              ? [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn-link dropdown-item",
                                                      attrs: {
                                                        "data-actions-disqualify-by-problem":
                                                          run.guid
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "disqualify",
                                                            {
                                                              run: run,
                                                              disqualificationType:
                                                                _vm
                                                                  .DisqualificationType
                                                                  .ByProblem
                                                            }
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.T
                                                              .arenaRunsActionsDisqualifyByProblem
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn-link dropdown-item",
                                                      attrs: {
                                                        "data-actions-disqualify-by-user":
                                                          run.guid
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "disqualify",
                                                            {
                                                              run: run,
                                                              disqualificationType:
                                                                _vm
                                                                  .DisqualificationType
                                                                  .ByUser
                                                            }
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.T
                                                              .arenaRunsActionsDisqualifyByUser
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : _vm._e()
                                          ]
                                        : run.type === "disqualified"
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn-link dropdown-item",
                                              attrs: {
                                                "data-actions-requalify":
                                                  run.guid
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.$emit(
                                                    "requalify",
                                                    run
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.T
                                                      .arenaRunsActionsRequalify
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ])
                        ])
                      : _c("td")
                  ])
                }),
                0
              )
            ])
          ])
        ]
      ),
      _vm._t("runs", [
        _c("omegaup-overlay", {
          attrs: {
            "show-overlay":
              _vm.currentPopupDisplayed !== _vm.PopupDisplayed.None
          },
          on: { "hide-overlay": _vm.onPopupDismissed },
          scopedSlots: _vm._u([
            {
              key: "popup",
              fn: function() {
                return [
                  _c("omegaup-arena-rundetails-popup", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.currentPopupDisplayed ===
                          _vm.PopupDisplayed.RunDetails,
                        expression:
                          "currentPopupDisplayed === PopupDisplayed.RunDetails"
                      }
                    ],
                    attrs: { data: _vm.currentRunDetailsData },
                    on: { dismiss: _vm.onPopupDismissed }
                  })
                ]
              },
              proxy: true
            }
          ])
        })
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }